import { render } from "./Agenzia.vue?vue&type=template&id=9ce47856"
import script from "./Agenzia.vue?vue&type=script&lang=js"
export * from "./Agenzia.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__